module.exports = __webpack_public_path__ + "img/icon-playlist.108a195b.svg";